/** Spec §4 — folder template per customer. The customer root is `{account_number}`. */
export const CUSTOMER_FOLDER_TEMPLATE = [
    { name: 'Credit', documentTypes: ['CREDIT_APP', 'PERS_GUAR', 'FINANCIAL'], defaultRoles: ['Credit.Analyst'] },
    { name: 'Compliance', documentTypes: ['RESALE_CERT', 'W9'], defaultRoles: ['Credit.Analyst', 'AR.Specialist', 'Sales.Branch'] },
    { name: 'Legal', documentTypes: ['LEGAL'], defaultRoles: ['Credit.Analyst', 'AR.Specialist'] },
    { name: 'Other', documentTypes: ['CUSTOMER_OTHER'], defaultRoles: ['Credit.Analyst', 'AR.Specialist', 'Sales.Branch'] },
    { name: 'Jobs', documentTypes: [], defaultRoles: ['AR.Specialist', 'Sales.Branch'], perSite: 'open' },
    { name: 'Archive', documentTypes: [], defaultRoles: ['AR.Specialist', 'Sales.Branch'], perSite: 'archived' },
];
/** Document types inside each `Jobs/{job_reference}` and `Archive/{job_reference}` folder. */
export const SITE_DOCUMENT_TYPES = ['PRELIM', 'LIEN_REL_COND', 'LIEN_REL_UNCOND', 'JOB_INFO', 'BID_REQ', 'JOB_DOC'];
/** Spec §4 — folder template per supplier. The supplier root is `{supplier_number}`. */
export const SUPPLIER_FOLDER_TEMPLATE = [
    { name: 'Financial', documentTypes: ['SUPPLIER_W9', 'SUPPLIER_TIN', 'SUPPLIER_BANK'], defaultRoles: ['Purchasing'] },
    { name: 'Insurance', documentTypes: ['SUPPLIER_INS'], defaultRoles: ['Purchasing'] },
    { name: 'Contracts', documentTypes: ['SUPPLIER_CONTRACT'], defaultRoles: ['Purchasing'] },
    { name: 'Archive', documentTypes: ['SUPPLIER_ARCHIVE'], defaultRoles: ['Purchasing'] },
    { name: 'Other', documentTypes: ['SUPPLIER_OTHER'], defaultRoles: ['Purchasing'] },
];
export function folderTemplateFor(entityType) {
    switch (entityType) {
        case 'customer':
            return CUSTOMER_FOLDER_TEMPLATE;
        case 'supplier':
            return SUPPLIER_FOLDER_TEMPLATE;
        case 'site':
            return [];
    }
}
/** Job folder display name (D4): the AR job reference, with the site id as a fallback. */
export function siteFolderName(jobReference, siteId) {
    const ref = (jobReference ?? '').trim();
    return ref.length > 0 ? ref : `Site ${siteId}`;
}
//# sourceMappingURL=folder-templates.js.map